// extracted by mini-css-extract-plugin
export var formContainer = "_gc-0";
export var message = "_gc-1";